import React from 'react';
import MatchItem from './MatchItem';
import { formatDate } from '../utils/formatters';
import '../styles/Matches.css';

const MatchesList = ({ matches, isCompleted = false, isLoading = false, matchDate }) => {
  // Group matches by date

  const groupMatchesByDate = () => {
    const groupedMatches = {};
    
    matches.forEach(match => {
      if (!groupedMatches[match.date]) {
        groupedMatches[match.date] = [];
      }
      groupedMatches[match.date].push(match);
    });
    
    return groupedMatches;
  };

  // Sort dates based on whether it's completed matches (newest first) or upcoming (oldest first)
  const getSortedDates = (groupedMatches) => {
    return Object.keys(groupedMatches).sort((a, b) => {
      if (isCompleted) {
        return new Date(b) - new Date(a); // Reverse chronological for completed
      }
      return new Date(a) - new Date(b); // Chronological for upcoming
    });
  };

  if (isLoading) {
    return <div className="spinner"></div>;
  }

  if (!matches || matches.length === 0) {
    return (
      <div className="empty-state">
        <h3>{isCompleted ? 'No results in this range' : 'No matches scheduled'}</h3>
        <p>
          {isCompleted
            ? 'Try another date, or clear the filter to see the latest results.'
            : 'Check back when the next event is announced.'}
        </p>
      </div>
    );
  }

  const groupedMatches = groupMatchesByDate();
  const sortedDates = getSortedDates(groupedMatches);

  return (
    <div className="matches-container">
      {sortedDates.map(date => (
        <React.Fragment key={date}>
          <div className="date-separator">{formatDate(date)}</div>
          {groupedMatches[date].map(match => (
            <MatchItem
              key={match.matchid}
              match={match}
              isCompleted={isCompleted}
              date={matchDate}
              hideDate
            />
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

export default MatchesList;
